import { FormType, InputType } from '@fitogest/reactive-form-builder/interfaces';
import { TareaRiegoModel } from '../../../../../../models/tareas/tarea-riego.model';
import { MtoReactiveFormDefinition, MtoSectionSpec } from '../../../mto-reactive/mto-reactive-form-definition';
import { getDropdownSelectedArray, getDropdownSelectedSingle } from '@fitogest/reactive-form-builder/utils';

export class TareasMtoRiegoFormDefinition extends MtoReactiveFormDefinition<TareaRiegoModel> {
    private readonly nameLabelFieldsSectors = this.env.appName === 'detorres' ? 'Zona' : 'Sector';

    constructor(type: FormType = FormType.CREATION, model: Partial<TareaRiegoModel> = {}) {
        super(type, model);

        this.initializeMtoForm({
            name: 'riego',
            header: 'Datos de riego',
            database: 'tareas_mto_riego',
            signatureFolder: 'riego',
            sections: this.getSections(),
        });
    }

    private getSections(): MtoSectionSpec<TareaRiegoModel>[] {
        return [
            { name: 'Datos de riego', fields: [...this.getRiegoMainFields()] },
            { name: 'Sectores', fields: [
                this.field('minutos_sector1', `${this.nameLabelFieldsSectors} 1 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector1', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector2', `${this.nameLabelFieldsSectors} 2 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector2', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector3', `${this.nameLabelFieldsSectors} 3 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector3', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector4', `${this.nameLabelFieldsSectors} 4 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector4', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector5', `${this.nameLabelFieldsSectors} 5 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector5', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector6', `${this.nameLabelFieldsSectors} 6 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector6', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector7', `${this.nameLabelFieldsSectors} 7 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector7', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector8', `${this.nameLabelFieldsSectors} 8 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector8', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector9', `${this.nameLabelFieldsSectors} 9 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector9', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector10', `${this.nameLabelFieldsSectors} 10 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector10', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector11', `${this.nameLabelFieldsSectors} 11 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector11', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector12', `${this.nameLabelFieldsSectors} 12 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector12', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector13', `${this.nameLabelFieldsSectors} 13 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector13', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector14', `${this.nameLabelFieldsSectors} 14 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector14', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
                this.field('minutos_sector15', `${this.nameLabelFieldsSectors} 15 (minutos)`, InputType.NUMERIC, { width: 3 }),
                this.field('metodo_sector15', `Método`, InputType.SELECT_BUTTON, { data: this.lists.metodosRiego, width: 3 }),
            ] },
            { name: 'Aspersores', fields: [
                this.field('aspersores_medio', `1/2`, InputType.NUMERIC, { width: 3 }),
                this.field('aspersores_tres_cuartos', `3/4`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Difusores', fields: [
                this.field('difusores', `Difusores`, InputType.NUMERIC, { width: 3 }),
                this.field('boquillas_difusor', `Boquillas Difusor`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Arqueta', fields: [
                this.field('arquetas', `Arquetas`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Arquetas', fields: [
                this.field('arquetas_rectangular', `Rectangular`, InputType.NUMERIC, { width: 3 }),
                this.field('arquetas_circular', `Circular`, InputType.NUMERIC, { width: 3 }),
                this.field('arquetas_cuadrada', `Cuadrada`, InputType.NUMERIC, { width: 3 }),
                this.field('arquetas_baja', `Baja`, InputType.NUMERIC, { width: 3 }),
                this.field('arquetas_jumbo', `Jumbo`, InputType.NUMERIC, { width: 3 }),
                this.field('arquetas_jumbo_baja', `Jumbo Baja`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Electroválvulas 9v Latch', fields: [
                this.field('electrovalvulas9v_una_pulgada', `1"`, InputType.NUMERIC, { width: 3 }),
                this.field('electrovalvulas9v_media_pulgada', `1 1/2"`, InputType.NUMERIC, { width: 3 }),
                this.field('electrovalvulas9v_dos_pulgadas', `2"`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Electroválvulas 24v', fields: [
                this.field('electrovalvulas24v_una_pulgada', `1"`, InputType.NUMERIC, { width: 3 }),
                this.field('electrovalvulas24v_media_pulgada', `1 1/2"`, InputType.NUMERIC, { width: 3 }),
                this.field('electrovalvulas24v_dos_pulgadas', `2"`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Solenoides', fields: [
                this.field('solenoides_9v_latch', `9v Latch`, InputType.NUMERIC, { width: 3 }),
                this.field('solenoides_24v', `24v`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Programador pilas', fields: [
                this.field('programador_pilas_1', `1`, InputType.NUMERIC, { width: 3 }),
                this.field('programador_pilas_2', `2`, InputType.NUMERIC, { width: 3 }),
                this.field('programador_pilas_4', `4`, InputType.NUMERIC, { width: 3 }),
                this.field('programador_pilas_6', `6`, InputType.NUMERIC, { width: 3 }),
                this.field('programador_pilas_8', `8`, InputType.NUMERIC, { width: 3 }),
                this.field('programador_pilas_10', `10`, InputType.NUMERIC, { width: 3 }),
                this.field('programador_pilas_12', `12`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Programador 220v', fields: [
                this.field('programador220v_1', `1`, InputType.NUMERIC, { width: 3 }),
                this.field('programador220v_2', `2`, InputType.NUMERIC, { width: 3 }),
                this.field('programador220v_4', `4`, InputType.NUMERIC, { width: 3 }),
                this.field('programador220v_6', `6`, InputType.NUMERIC, { width: 3 }),
                this.field('programador220v_8', `8`, InputType.NUMERIC, { width: 3 }),
                this.field('programador220v_10', `10`, InputType.NUMERIC, { width: 3 }),
                this.field('programador220v_12', `12`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Caja conexión', fields: [
                this.field('caja_conexion_1', `1`, InputType.NUMERIC, { width: 3 }),
                this.field('caja_conexion_2', `2`, InputType.NUMERIC, { width: 3 }),
                this.field('caja_conexion_4', `4`, InputType.NUMERIC, { width: 3 }),
                this.field('caja_conexion_6', `6`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Tubería goteo', fields: [
                this.field('tuberia_goteo_33cm', `33cm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_goteo_50cm', `50cm`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Tubería lisa', fields: [
                this.field('tuberia_lisa_16mm', `16mm`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Pilas', fields: [
                this.field('pilas_9v', `9v`, InputType.NUMERIC, { width: 3 }),
                this.field('pilas_otras', `Otras`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Tubería PE', fields: [
                this.field('tuberia_pe_20mm', `20mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_32mm', `32mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_40mm', `40mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_50mm', `50mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_63mm', `63mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_75mm', `75mm`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Tubería PE 2', fields: [
                this.field('tuberia_pe_16', `16--2,5`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_20', `20--6`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_25', `25--6`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_32', `32--6`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_40', `40--6`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_50', `50--6`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pe_63', `63--6`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Tubería PVC', fields: [
                this.field('tuberia_pvc_20mm', `20mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pvc_32mm', `32mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pvc_40mm', `40mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pvc_50mm', `50mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pvc_63mm', `63mm`, InputType.NUMERIC, { width: 3 }),
                this.field('tuberia_pvc_75mm', `75mm`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Riego manguera', fields: [
                this.field('riego_manguera', ``, InputType.TEXT, { width: 3 }),
            ] },
            { name: 'Depósito', fields: [
                this.field('cantidad_deposito1', ``, InputType.NUMERIC, { width: 3 }),
                this.field('cantidad_deposito2', ``, InputType.NUMERIC, { width: 3 }),
                this.field('cantidad_deposito3', ``, InputType.NUMERIC, { width: 3 }),
            ] },
            this.workerSection(this.env.appName === 'detorres' ? 'Trabajadores' : 'Profesionales'),
            this.workOrderSection(),
            this.observationSection(this.env.appName === 'donjardin' || this.env.appName === 'detorres' ? 'Observaciones' : 'Parte de Trabajo'),
        ];
    }

    private getRiegoMainFields(): MtoSectionSpec<TareaRiegoModel>['fields'] {
        return [
            ...this.getDefaultMainFieldSpecs(),
            this.field('id_sector', this.env.sectorName, InputType.MULTISELECT_SEARCH, {
                data: this.lists.sectores,
                valuePrimaryKey: 'id',
                isVisible: this.env.appName === 'detorres',
                filter: (it) => {
                    const selectedFinca = getDropdownSelectedSingle(this.lists.fincas);

                    return selectedFinca ? String((it.value as { id_finca?: unknown } | null)?.id_finca ?? '') === String(selectedFinca.id ?? '') : false;
                },
            }),
            this.field('ids_parcelas', this.env.parcelasName, InputType.MULTISELECT_SEARCH, {
                data: this.lists.parcelas,
                valuePrimaryKey: 'id',
                isRequired: true,
                isVisible: this.env.appName === 'detorres',
                filter: (it) => this.filterRiegoParcela(it.value as { activo?: unknown; id_finca?: unknown; id_sector?: unknown } | null),
            }),
        ];
    }

    private filterRiegoParcela(parcela: { activo?: unknown; id_finca?: unknown; id_sector?: unknown } | null): boolean {
        if (!parcela || String(parcela.activo ?? '') !== '1') {
            return false;
        }

        const selectedSectors = getDropdownSelectedArray(this.lists.sectores);

        if (selectedSectors.length > 0) {
            return selectedSectors.some((sector) => String(sector?.id ?? '') === String(parcela.id_sector ?? ''));
        }

        const selectedFinca = getDropdownSelectedSingle(this.lists.fincas);

        if (selectedFinca) {
            return String(parcela.id_finca ?? '') === String(selectedFinca.id ?? '');
        }

        return false;
    }
}
